import axios from 'axios';
import {
  CREATE_FORM_SECTION_URL,
  GET_FORM_STRUCTURE_URL,
  GET_FORM_TREE_URL,
  CREATE_MAIN_SECTION_URL,
  DELETE_MAIN_SECTION_URL,
  GET_MAIN_SECTIONS_BY_FORM_URL,
  REORDER_FORM_SECTION_URL,
  REORDER_MAIN_SECTIONS_URL,
  SOFT_DELETE_FORM_SECTION_URL,
  UPDATE_MAIN_SECTION_URL,
  get_request_config,
} from '@/utils/system_constants/constant.js';

const form_structure_cache = new Map();

function parse_json_string(value, fallback = {}) {
  try { return JSON.parse(value); }
  catch { return fallback; }
}

function parse_response_data(response) {
  const raw_data = response?.data ?? response ?? {};

  if (typeof raw_data !== 'string') {
    return raw_data;
  }

  const parsed_data = parse_json_string(raw_data);

  return typeof parsed_data === 'string' ? parse_json_string(parsed_data) : parsed_data;
}

function extract_items(response) {
  const parsed = parse_response_data(response);
  const items = parsed?.data ?? parsed?.results ?? [];

  return Array.isArray(items) ? items : [];
}

export const create_main_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(CREATE_MAIN_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const fetch_main_sections_by_form = async (form_id) => {
  const request_config = get_request_config({
    params: {
      form_id,
    },
  });
  const response = await axios.get(GET_MAIN_SECTIONS_BY_FORM_URL, request_config);

  return extract_items(response);
};

export const create_sub_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(CREATE_FORM_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const soft_delete_form_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(SOFT_DELETE_FORM_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const reorder_main_sections = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(REORDER_MAIN_SECTIONS_URL, payload, request_config);

  return parse_response_data(response);
};

export const update_main_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(UPDATE_MAIN_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const delete_main_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(DELETE_MAIN_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const reorder_form_section = async (payload) => {
  const request_config = get_request_config();
  const response = await axios.post(REORDER_FORM_SECTION_URL, payload, request_config);

  return parse_response_data(response);
};

export const fetch_form_structure = async (form_id) => {
  const cache_key = String(form_id || '');
  if (form_structure_cache.has(cache_key)) {
    return form_structure_cache.get(cache_key);
  }

  const request_config = get_request_config({
    params: {
      form_id,
    },
  });
  const request = axios.get(GET_FORM_STRUCTURE_URL, request_config)
    .then((response) => extract_items(response))
    .catch((error) => {
      form_structure_cache.delete(cache_key);
      throw error;
    });

  form_structure_cache.set(cache_key, request);
  return request;
};

export const fetch_form_tree = async ({
  application_id,
  application_form_id,
  form_main_section_id,
  entity_profile_id,
  current_status_id
} = {}) => {
  const response = await axios.get(
    GET_FORM_TREE_URL,
    get_request_config({
      params: {
        application_id,
        application_form_id,
        form_main_section_id,
        entity_profile_id,
        current_status_id
      }
    })
  );

  const parsed = parse_response_data(response);

  return {
    data: Array.isArray(parsed?.data) ? parsed.data : [],
    allowed_actions: Array.isArray(parsed?.allowed_actions) ? parsed.allowed_actions : [],
    user_full_name: parsed?.user_full_name || '',
    user_id: parsed?.user_id || null
  };
};
